export const dateFilterWrapperStyles = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  padding: '12px 0',
};

export const dateFieldWrapperStyles = {
  flex: '0 0 auto',
  maxWidth: '200px',
};
